import React, { ChangeEvent } from 'react';
import Row from 'react-bootstrap/Row';
import { FieldCol } from '../styled/ContactsForm';
import { StyledFormControl } from '../styled/Inputs';
import { TAppContact, TAppName } from 'TProtocol/common/models';

interface Props {
  contact: TAppContact;
  onChange: (contact: TAppContact) => void;
  autocomplete?: boolean;
}

const NameFields = ({ contact, onChange, autocomplete = false } : Props) => {
  let firstName = '';
  let middleName = '';
  let lastName = '';
  let prefix = '';
  let suffix = '';

  if (contact.name) {
    firstName = contact.name.firstName ?? '';
    middleName = contact.name.middleName ?? '';
    lastName = contact.name.lastName ?? '';
    prefix = contact.name.prefix ?? '';
    suffix = contact.name.suffix ?? '';
  }

  const handleNameChange = <K extends keyof TAppName, V extends TAppName[K]>(
    value: V,
    fieldAttribute: K
  ) => {
    if (!contact.name) {
      contact.name = new TAppName();
    }

    contact.name[fieldAttribute] = value;

    let fullName = '';
    if (contact.name.firstName && contact.name.firstName.length > 0) {
      fullName = contact.name.firstName;
    }
    if (contact.name.middleName && contact.name.middleName.length > 0) {
      if (fullName.length > 0) {
        fullName = fullName + ' ' + contact.name.middleName;
      } else {
        fullName = contact.name.middleName;
      }
    }
    if (contact.name.lastName && contact.name.lastName.length > 0) {
      if (fullName.length > 0) {
        fullName = fullName + ' ' + contact.name.lastName;
      } else {
        fullName = contact.name.lastName;
      }
    }

    if (fullName.length > 0) {
      contact.name['fullName'] = fullName;
    }

    onChange(contact);
  };

  return <>
    <div className="form-group">
      <Row data-contact-id={contact.contactId} className="gx-2">
        <FieldCol>
          <StyledFormControl
            autoComplete={autocomplete ? 'given-name' : 'do-not-autocomplete'}
            placeholder="First Name"
            defaultValue={firstName}
            onChange={(e: ChangeEvent<HTMLInputElement>) => handleNameChange(e.target.value, 'firstName')}/>
        </FieldCol>
        <FieldCol>
          <StyledFormControl
            autoComplete={autocomplete ? 'additional-name' : 'do-not-autocomplete'}
            placeholder="Middle Name"
            defaultValue={middleName}
            onChange={(e: ChangeEvent<HTMLInputElement>) => handleNameChange(e.target.value, 'middleName')}/>
        </FieldCol>
        <FieldCol>
          <StyledFormControl
            autoComplete={autocomplete ? 'family-name' : 'do-not-autocomplete'}
            placeholder="Last Name"
            defaultValue={lastName}
            onChange={(e: ChangeEvent<HTMLInputElement>) => handleNameChange(e.target.value, 'lastName')}/>
        </FieldCol>
      </Row>
      <Row className="gx-2">
        <FieldCol>
          <StyledFormControl
            autoComplete={autocomplete ? 'honorific-prefix' : 'do-not-autocomplete'}
            placeholder="Prefix"
            defaultValue={prefix}
            onChange={(e: ChangeEvent<HTMLInputElement>) => handleNameChange(e.target.value, 'prefix')}/>
        </FieldCol>
        <FieldCol>
          <StyledFormControl
            autoComplete={autocomplete ? 'honorific-suffix' : 'do-not-autocomplete'}
            placeholder="Suffix"
            defaultValue={suffix}
            onChange={(e: ChangeEvent<HTMLInputElement>) => handleNameChange(e.target.value, 'suffix')}/>
        </FieldCol>
      </Row>
    </div>
  </>
}

export default NameFields;
